// Libarary
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// View Model
import { AccountVM } from '../../models/AccountMasterVM';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { BroadcastService } from '../infrastructure/broadcaster.service';
import { NetworkService } from '../infrastructure/network.service';
import { MasterConstants } from '../../common/constants/master-constants';

@Injectable()
export class CppReturnsService {
  public SelectedAccountObj: BehaviorSubject<AccountVM>;
  // public isAccountSelectedOnLP: boolean = false;
  // public isGrowerSelectedOnLP: boolean = false;
  // public SelectedGwrOrderId: BehaviorSubject<string>;
  // public SelectedProductLineId: BehaviorSubject<string>;
  public selectedAccountNo: any;
  public selectedAccountParentNo: any;
  public isEditMode = false;
  public productList: any = [];
  public redirectFrom: any;
  public returnRequestStatus: string;
  //public dashboardSelectedProductLine: string = 'All';
  isReturnTypeForInnoculant: boolean = false;

  constructor(public broadcastService: BroadcastService,
    public configService: ConfigService,
    private networkService: NetworkService) {
    this.SelectedAccountObj = new BehaviorSubject<AccountVM>(null);
    this.returnRequestCppId = new BehaviorSubject(0);
  }
  webOrderNumberAndSplitId: any;
  returnRequestCppId: BehaviorSubject<number>;

  public setCppReturnRequestId(value: number) {
    this.returnRequestCppId.next(value);
  }
  public setReturnRequestStatus(value: string) {
    this.returnRequestStatus = value;
  }
  public setRedirectionFrom(value) {
    this.redirectFrom = value;
  }

  getSelectedAccountNo() {
    return this.selectedAccountNo;
  }

  setSelectedAccountNo(selectedAccountNo) {
    this.selectedAccountNo = selectedAccountNo;
  }

  public setIsReturnTypeForInoculant(value: boolean) {
    this.isReturnTypeForInnoculant = value;
  }

  getSelectedParentAccountNo() {
    return this.selectedAccountParentNo;
  }

  setSelectedParentAccountNo(selectedAccountParentNo) {
    this.selectedAccountParentNo = selectedAccountParentNo;
  }

  getEditModeStatus() {
    return this.isEditMode;
  }

  setEditModeStatus(isEditMode) {
    this.isEditMode = isEditMode;
  }
  getProductList() {
    return this.productList;
  }

  setProductList(productList) {
    this.productList = productList;
  }
  public AccountChange(obj: AccountVM) {
    this.SelectedAccountObj.next(obj);
  }
  // Get Item Number List
  public getItemNumberList() {
    return this.networkService.getRequest(this.configService.getCppReturnsItemNumberDataUrl);
  }
  // Get Account detail data for Account dropdown
  public getAccountList() {
    return this.networkService.getRequest(this.configService.cppReturnsAccountListUrl);
  }

  // Get Cpp Order Items List
  public getReturnRequestList(filters) {
    return this.networkService.postRequest(this.configService.getCppReturnsRequestUrl, filters);
  }

  public getReturnRequestReport(filters) {
    return this.networkService.postRequest(this.configService.getCppReturnsRequesReporttUrl, filters);
  }

  // Get Access Request For NewReturn Button/ Draft Tab
  public getReturnAccessRequest(productLineID) {
    return this.networkService.getRequest(this.configService.getAccessRequestCPP + '?productLineID=' + productLineID);
  }

  // Get DSM info
  public getDSMInfo(accountNo, cropYear) {
    return this.networkService.getRequest(this.configService.getCppReturnsDsmInfoUrl + '?accountNumber=' + accountNo + '&cropYear=' + cropYear);
  }

  // Get lot number list
  public getInvoiceNumberList(accountNo) {
    return this.networkService.getRequest(this.configService.getCppReturnsInvoiceNumberListUrl + '?accountNumber=' + accountNo);
  }
  // Get invoiced product list for grid
  public getInvoicedProductItems(filters) {
    return this.networkService.postRequest(this.configService.getCppReturnsInvoicedProductItemsUrl, filters);
  }

  // Get product list
  public getProductMaster(filters) {
    return this.networkService.postRequest(this.configService.getCppReturnsForManualProductsUrl, filters);
  }

  // Get product list
  public getProductUOM(filters) {
    return this.networkService.postRequest(this.configService.getCppReturnsForItemUOMUrl, filters);
  }

  // Get lot master list
  // public getLotMasterList(accountNumber) {
  //  return this.networkService.getRequest(this.configService.getLotMasterItems() + '?accountNumber=' + accountNumber);
  // }

  // Get lot master list
  // public getManualLotMasterList(productLineId) {
  //  return this.networkService.getRequest(this.configService.getManualLotMasterItems() + '?productLineId=' + productLineId);
  // }

  // Get products by lot number
  // public getItemLotList(filters) {
  //  return this.networkService.postRequest(this.configService.getItemsForManualProducts(), filters);
  // }

  public submitReturnRequest(data) {
    return this.networkService.postRequest(this.configService.saveCppReturnsRequestItemsUrl, data);
  }

  public submitToJDEReturnRequest(data) {
    return this.networkService.postRequest(this.configService.submitToJDECppReturnsRequestItemsUrl, data);
  }

  // public getScaleTicketFile(scaleTicketId) {
  //  return this.networkService.getRequest(this.configService.getScaleTicketFile() + '?scaleTicketId=' + scaleTicketId);
  // }

  // Get Edit request detail
  public getEditRequestDetail(requestId) {
    return this.networkService.getRequest(this.configService.getCppReturnsRequestEditDetailDataUrl + '?requestId=' + requestId);
  }

  // Get products by lot number
  // public deleteScaleTicket(data) {
  //  return this.networkService.postRequest(this.configService.deleteScaleTicket(), data);
  // }

  // Delete Order
  public deleteRequest(returnRequestId) {
    return this.networkService.postRequest(this.configService.deleteCppReturnRequestUrl, returnRequestId);
  }

  // Get account user
  public getAccountUser(accountNumber) {
    return this.networkService.getRequest(this.configService.accountUserCppReturnRequestUrl + '?accountNumber=' + accountNumber);
  }

  // Get scale ticket file extensions
  // public getScaleTicketFileExtensions() {
  //  return this.networkService.getRequest(this.configService.getScaleTicketFileExtensions());
  // }

  // Get Banner Message url
  public getBannerMessage() {
    return this.networkService.getRequest(this.configService.cppReturnsBannerMessageUrl);
  }

  // Get Deliver To Facility List
  public getDeliverToFacilityList(accountNumber, shipToAccountParentNumber) {
    const url = this.configService.getAPIPath(this.configService.getCppReturnsDeliverToFacilityDataUrl,
      { accountNumber: accountNumber, shipToAccountParentNumber: shipToAccountParentNumber });
    return this.networkService.getRequest(url);
  }

  public getReturnMaster() {
    return this.networkService.getRequest(this.configService.getCppReturnsReturnMasterDataUrl);
  }

  // Get produt line list
  public getProductLineList() {
    return this.networkService.getRequest(this.configService.CPPProductLineListUrl);
  }

  // check OTI Orders Exist for Customer PO
  public checkOTIOrders(shipToAccount, customerPO) {
    return this.networkService.getRequest(this.configService.cppReturnsCheckOTIOrdersUrl + '?shipToAccount=' + shipToAccount + '&customerPO=' + customerPO);
  }

  // Get return request header id by inputs value for draft
  public getDraftReturnRequest(accountNumber) {
    const url = this.configService.getAPIPath(this.configService.getDraftCppReturnsRequestDataUrl,
      { accountNumber: accountNumber });
    return this.networkService.getRequest(url);
  }

  // Get Cpp Sold To Facility
  public getSoldToFacility(accountNumber) {
    return this.networkService.getRequest(this.configService.getCppSoldToFacilityData() + '?accountNumber=' + accountNumber);
  }

  // Get account SDM
  public getAccountSDMData(accountNumber, inoculantReturnType) {
    return this.networkService.getRequest(this.configService.CPPReturnsAccountSDMDataUrl + '?accountNumber=' + accountNumber + '&inoculantReturnType=' + inoculantReturnType);
  }

  getCPPReturnsInoculantWarningMessage() {
    return this.networkService.getRequest(this.configService.getCPPReturnInoculantWarningMessage());
  }

  getCPPReturnsInoculantErrorMessage() {
    return this.networkService.getRequest(this.configService.getCPPReturnInoculantErrorMessage());
  }
  getInoculantRestriction() {
    return this.networkService.getRequest(this.configService.getInoculantRestriction());
  }

  getCPPReturnsReportDistributionEmailForInoculant() {
    return this.networkService.getRequest(this.configService.getCPPReturnInoculantReportDistributionEmail());
  }
}
